import React from 'react'
import Translation from '../../Translation/cont/Translation'
import getDisabledClass from '../../../functions/getDisabledClass'

const OverlaySubmitCancelButtons = ({
    transIdCancel='cancel_button',
    transIdSubmit="save_button",
    editDisabled,
    onClose
}) => (
    <div className="button-wrapper">
        <div className="cancel-button-wrapper">
            <button className="button-cancel" onClick={() => onClose()}><span className=''><Translation id={transIdCancel} /></span></button>
        </div>

        <div className={getDisabledClass("save-button-wrapper", false, editDisabled)}>
            <button type="submit "className="button-save">
                <span className=''><Translation id={transIdSubmit} /></span>
            </button>
        </div>
    </div>
)

export default OverlaySubmitCancelButtons